import { NAV_LINKS, BRAND, LOCATIONS } from '@/data/content';
import { scrollToId } from '@/lib/smoothScroll';

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-void border-t border-ink/10 section-pad pt-20 pb-10">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
      <div>
        <div className="flex items-center gap-3">
          <img src="/assets/logo-mark.png" alt="Jupally Avenues" className="h-10 w-auto" />
          <p className="font-clash font-semibold text-2xl tracking-tight text-[#1E3A7B]">JUPALLY <span className="text-brand-gold">AVENUES</span></p>
        </div>
        <p className="mt-3 text-xs text-ink/70 leading-relaxed max-w-xs">
          {BRAND.tagline}. Real estate is more than developing land — it is building trust,
          creating lasting value and shaping communities for generations.
        </p>
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-[0.3em] text-ink/55 mb-5">Navigate</p>
        <div className="flex flex-col gap-2.5">
          {NAV_LINKS.map((l) => (
            <button key={l.id} data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)} className="text-left text-sm text-ink/70 hover:text-brand-gold transition-colors duration-300 w-fit">
              {l.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-[0.3em] text-ink/55 mb-5">Where we build</p>
        <p className="text-xs text-ink/70 leading-loose max-w-xs">{LOCATIONS.join(' · ')}</p>
      </div>
    </div>
    <div className="border-t border-ink/10 pt-6 flex flex-col md:flex-row justify-between gap-3">
      <p className="text-[11px] text-ink/55">© {new Date().getFullYear()} {BRAND.legal} · {BRAND.partner}</p>
      <p className="text-[11px] text-ink/55">Crafted with precision in Hyderabad</p>
    </div>
  </footer>
);
